import React from 'react'

const Legal = () => {
  return (
    <div className='bg-white py-32 px-6 lg:px-8'>
    <h2 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Impressum</h2>
    <p className="mt-10 text-base leading-7 text-gray-700 ">Angaben gemäß § 5 TMG</p>
    <p className="mt-10 text-base leading-7 text-gray-700 ">Ghazi Bayazid <br></br>
        Abu-Jo Trading <br></br>
        Schützenstraße 44<br></br>
        40723 Hilden <br></br>
        </p>
    <p className="mt-10 text-base leading-7 text-gray-700 "> <strong>Vertreten durch: </strong><br></br>
        Ghazi Bayazid<br></br>
    </p>
    <p className="mt-10 text-base leading-7 text-gray-700 "><strong>Kontakt:</strong> <br></br>
        Telefon: (+49) 0171 2056506<br></br>
        E-Mail: <a href='mailto:rasi1340@t-online.de'>rasi1340@t-online.de</a><br></br>
    </p>
    <p className="mt-10 text-base leading-7 text-gray-700 "><strong>Umsatzsteuer-ID: </strong> <br></br>
        Umsatzsteuer-Identifikationsnummer gemäß §27a Umsatzsteuergesetz: DE 813 141 599<br></br>
    </p>

    </div>
  )
}

export default Legal